import { CIcon } from '~/icons/types'

export const ciSnowsports: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm4.969 9.073.1.168h5.653L6.45 7.75a1.23 1.23 0 0 0-1.237.22.953.953 0 0 0-.3.966.707.707 0 0 0 .056.136Z'
    },
    {
      d:
        'm23.86 15.86-.16-.375a.494.494 0 0 0-.909.384l.16.375a.33.33 0 0 1-.038.333.726.726 0 0 1-.614.286h-.975l-2.41-3.211h3.052a1.263 1.263 0 0 0 .914-2.138l-.028-.028-5.813-5.2a.491.491 0 0 0-.656.73l1.978 1.773-3.5 1.158-.149.047H5.185a3.638 3.638 0 0 0-2.724 1.858.255.255 0 0 0-.023.06l-.4 1.149h9.112a2.893 2.893 0 0 1 2.878 2.653h2.236a.5.5 0 0 0 .366-.164l1.355-1.514 2.123 2.827h-5.15a.492.492 0 1 0 0 .984H22.3a1.713 1.713 0 0 0 1.435-.722 1.33 1.33 0 0 0 .125-1.265Z'
    },
    {
      d:
        'M11.147 14.04H1.936a1.903 1.903 0 0 0 0 3.805h9.211a1.903 1.903 0 0 0 0-3.806Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'snowsports',
  type: 'solid'
}
